/**
 * Logo thumb / card surfaces (not full welcome hero tile — see `welcomeHero.ts`).
 * Uses `ThemeColors` so light/dark and brand updates apply (avoid frozen `appTheme.colors` at module load).
 * @see atomicRules.ts
 * Used by: `OrganizationLogo`.
 */
import { Platform, StyleSheet, type ImageStyle, type ViewStyle } from 'react-native';
import { appTheme } from '../appTheme';
import type { ThemeColors } from '../store';

function logo_card_shadow(c: ThemeColors): ViewStyle {
  const base = { ...appTheme.shadows.card };
  if (Platform.OS === 'ios') {
    return { ...base, shadowColor: c.shadowColor };
  }
  return base;
}

export function createOrganizationLogoStyles(c: ThemeColors) {
  return StyleSheet.create({
    logoCard: {
      width: 150,
      height: 150,
      borderRadius: appTheme.borderRadius.xl,
      // backgroundColor: c.surface,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      overflow: 'hidden',
      ...logo_card_shadow(c),
    },
    logoPlaceholder: {
      width: 80,
      height: 80,
      borderRadius: appTheme.borderRadius.md,
      backgroundColor: c.surfaceFade,
    },
    /** Size only — scaling uses `<Image resizeMode="…" />` (see `OrganizationLogo`); RN does not support CSS `imageFit` / `imagePosition` in styles. */
    logoImage: {
      width: 150,
      height: 150,
    } as ImageStyle,
  });
}
